import { useSocket } from '@/providers/socket-io';
import { createContext, useEffect, useRef } from 'react';
import { SOCKET_EVENTS } from '@/constants/socket.ts';
import { jsonTryParse } from '@/utility';
import { useNotificationStore } from '@/zustand/notification/notificationStore.ts';
import { useLocation } from 'react-router';
import { NavigationPath } from '@/router/navigation-path.ts';
import { useQueryClient } from 'react-query';
import { QUERY_KEYS } from '@/constants/QueryKeys.ts';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
	const { socket, on, off } = useSocket();
	const socketRef = useRef(null);
	const location = useLocation();
	const queryClient = useQueryClient();

	const updateNotificationCount = useNotificationStore(s => s.setUnreadNotificationCount);

	useEffect(() => {
		if (!socket) return;

		const handler = async data => {
			const dataParsed = jsonTryParse(data);
			if (dataParsed?.unreadCount) {
				updateNotificationCount(dataParsed.unreadCount);
			}

			if (location?.pathname === NavigationPath.notifications) {
				await queryClient.refetchQueries(QUERY_KEYS.getNotificationsByExpertId);
			}
		};

		on(SOCKET_EVENTS.ON.NOTIFICATION_CREATED, handler);

		return () => {
			off(SOCKET_EVENTS.ON.NOTIFICATION_CREATED, handler);
		};
	}, [socket]);

	return <NotificationContext.Provider value={socketRef.current}>{children}</NotificationContext.Provider>;
};
